export interface RemoteChargingSessionRfidCard {
  tokenId: string;
  tokenOwner?: string;
}
